import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _inherits from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import ge from "./base-device-parser.js";
import { Browsers as gi } from "./device-constants.js";
var ai = /*#__PURE__*/function (_ge) {
  _inherits(ai, _ge);
  var _super = _createSuper(ai);
  function ai() {
    var _this;
    _classCallCheck(this, ai);
    if (_this = _super.call(this), _this.userAgentData = navigator.userAgentData, _this.browser = null, _this.version = null, _this.userAgentData) {
      var t = _this.gc();
      _this.browser = t.browser || "Unknown Browser", _this.version = t.version || "Unknown Version";
    }
    _this.OS = null;
    return _possibleConstructorReturn(_this);
  }
  _createClass(ai, [{
    key: "ef",
    value: function ef() {
      return this.browser;
    }
  }, {
    key: "ff",
    value: function ff() {
      return this.version;
    }
  }, {
    key: "Ja",
    value: function Ja(t) {
      var _this2 = this;
      if (this.OS) return Promise.resolve(this.OS);
      var s = function s(_s) {
        for (var r = 0; r < t.length; r++) {
          var i = ai.nf(_s, t[r]);
          if (i) return _this2.OS = i, _this2.OS;
        }
        return _s;
      };
      return this.userAgentData.platform ? Promise.resolve(s(this.userAgentData.platform)) : this.getHighEntropyValues().then(function (t) {
        return t.platform ? s(t.platform) : navigator.platform;
      })["catch"](function () {
        return navigator.platform;
      });
    }
  }, {
    key: "gc",
    value: function gc() {
      var t = {},
        s = this.userAgentData.brands;
      if (s && s.length) {
        var _iterator = _createForOfIteratorHelper(s),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var r = _step.value;
            var _s2 = this.vc(gi),
              i = r.brand.match(_s2);
            if (i && i.length > 0) {
              t.browser = i[0], t.version = r.version;
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return t;
    }
  }, {
    key: "vc",
    value: function vc(t) {
      var s = [];
      for (var r in t) {
        var i = r;
        s.push(t[i]);
      }
      return new RegExp("(" + s.join("|") + ")", "i");
    }
  }, {
    key: "getHighEntropyValues",
    value: function getHighEntropyValues() {
      return this.userAgentData.getHighEntropyValues ? this.userAgentData.getHighEntropyValues(["platform"]) : Promise.reject();
    }
  }]);
  return ai;
}(ge);
export { ai as default };